import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import Form from './Form'
import { DivisionId, SenderId, ClientId, PrevilageId } from "../../helper/HelperAuth";
import DatePickerInput from "../../infra/components/formInput/DatePickerInput";
import ComboboxInput from "../../infra/components/formInput/ComboboxInput";
import ActionDownload from "../../store/action/UploadMediaId/Download"
import ActionGetMediaUpload from '../../store/action/UploadMediaId/Fetch'
import ActionGetAllClient from '../../store/action/Client/FetchAll'
import ActionGetAllDivision from '../../store/action/Division/FetchAll'
import ActionGetAllSender from '../../store/action/Sender/FetchAll'
import CustomGrid from '../../infra/components/grid/custom-grid-without-search'
import "../../source/util.css"
import { IsCreate } from '../../store/constants'
import ActionGetAccessModule from '../../store/action/AccessModule/Fetch'

class Page extends Component {
    constructor(props) {
        super(props)
        this.state = {
            title: "Upload Media Id",
            form: fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            }),
            action_id: this.handleActionId(),
            searchForm: fromJS({
                "client-id": '',
                "division-id": '',
                "sender-id": '',
                "start-date": "",
                "end-date": ""
            }),
            columns: [
                { className: "col-sm-1", cfield: "counter", caption: "No" },
                {
                    className: "col-sm-1", cfield: "action", caption: "Actions", allowEdit: false, allowView: false, allowDelete: false,
                    custom: fromJS([
                        { "id": "DownloadFileUpload", "icon": "cloud_download", "label": "", "title": "Download File Upload","className": "btn-trans btn-sm waves-effect text-success greens" },
                    ])
                },
                { className: "col-sm-2", field: "client-name", caption: "Client Name", allowSearch: true },
                { className: "col-sm-1", field: "division-name", caption: "Division", allowSearch: true },
                { className: "col-sm-1", field: "sender-name", caption: "Sender", allowSearch: true },
                { className: "col-sm-2", field: "file-name", caption: "File Name", allowSearch: true },
                { className: "col-sm-1", field: "media-id", caption: "Media Id", allowSearch: true },
                { className: "col-sm-1", field: "upload-date", caption: "Date Uploaded", allowSearch: true },
                { className: "col-sm-2", field: "expired-date", caption: "Expired Date", allowSearch: true }
            ],
            errors: fromJS({}),
            disrest: true,
        };

        this.showContent = this.showContent.bind(this);
        this.handleFindSearch = this.handleFindSearch.bind(this);
        this.handleFind = this.handleFind.bind(this);
        this.handleNew = this.handleNew.bind(this);
        this.handleCancelForm = this.handleCancelForm.bind(this);
        this.handlePageChanged = this.handlePageChanged.bind(this);
        this.handleCustomAction = this.handleCustomAction.bind(this);
    }

    async componentDidMount() {
        let formVal = this.state.searchForm
        await this.props.actionGetAccessModule(PrevilageId);
        let restrict = this.handleActionId()
        this.props.actionGetAllClient()
        console.log(restrict)
        if (restrict == 5) {
            await this.props.actionGetAllDivision(ClientId, 'Upload Media Id')
            this.props.actionGetAllSender(ClientId)
            formVal = formVal.set("client-id", ClientId)
            formVal = formVal.set("division-id", DivisionId)
            formVal = formVal.set("sender-id", SenderId)
            this.setState({
                searchForm: formVal,
                disrest: true
            })
        } else {
            this.setState({
                disrest: false
            })
        }

    }

    handleActionId() {
        let array = []
        let action = 0;
        let menuPrev = (this.props.accessmodules.get('data') != null ? this.props.accessmodules.get('data') : fromJS([]));
        {
            menuPrev.map((data, i) =>
                array.push({
                    'menu-name': data.get('menu-name'),
                    'action-id': data.get('action-id')
                })

            )
        }

        for (let i = 0; i < array.length; i++) {
            if (array[i]['menu-name'] === 'Upload Media Id') {
                action = array[i]['action-id'];
                this.state.action_id = array[i]['action-id'];
            }
        }
        return action;
    }

    handleOnBindCustomAction(actionId, row) {


        return true;
    }
    async handleCustomAction(id, row) {
        switch (id) {
            case "DownloadFileUpload":
                var result1 = await this.props.actionDownload(row.get('media-id'),row.get('file-type') , row.get('file-name'))
                //debugger;
                if (!result1.ok) {
                    toast.error("Download Failed", toast.POSITION.TOP_RIGHT);
                    this.handleFindSearch(1)
                }
                break;
            default:
        }
    }

    handleChange(field, value, label) {
        var formVal = this.state.searchForm;
        console.log(field,value)
        formVal = formVal.set(field, value);
        if (field === 'client-id') {
            formVal = formVal.set('sender-id', '')
            formVal = formVal.set('division-id', '')
            this.setState({ client_id: value })
            this.props.actionGetAllDivision(value);
            this.props.actionGetAllSender(value);
        }

        if (field === 'division-id') {
            formVal = formVal.set('sender-id', '')
            this.setState({ searchForm: formVal })
            this.props.actionGetAllSender(formVal.get("client-id"), value);
        }
        console.log(field)
        this.setState({ searchForm: formVal })

    }

    handleCancelForm(refresh) {
        if (refresh) {
            this.handleFindSearch(1);
        }
        this.setState({
            form: fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            })
        })
    }

    handleNew() {
        this.setState({
            form: fromJS({
                show: true,
                actionType: IsCreate,
                item: fromJS({})
            })
        })
    }

    handlePageChanged = (value) => {
        const { formSearch } = this.state;
        this.refreshGrid(value, formSearch);
    }

    handleFindSearch(page) {
        const { searchForm } = this.state;
        let sender_id = searchForm.get('sender-id');
        let client_id = searchForm.get('client-id');
        let division_id = searchForm.get('division-id');
        let sender = [];
        var bodyFInd = {};
        let res = null;
        if (client_id === "" || client_id === "null" || client_id === null) client_id = 0;
        if (division_id === "" || division_id === "null" || division_id === null) division_id = 0;

        if ((sender_id === "" || sender_id == undefined
            || sender_id === " " || sender_id === null
            || sender_id === "null" || sender_id === [""]) && client_id != 0) {
             if (PrevilageId != 1) {
            client_id = ClientId;
            division_id = DivisionId;
            }
            this.props.actionGetAllSender(client_id, division_id)

            setTimeout(() => {
                res = this.props.senderall;
                if (res.size > 0) {
                    sender = [];
                }

                {
                    res.map((data, i) =>
                        sender.push(data.get('sender-id'))
                    )
                }
                if(sender[0] == '') sender = []
                bodyFInd = {
                    "client-id": client_id,
                    "division-id": division_id,
                    "sender-id": sender,
                    "start-date": searchForm.get("start-date"),
                    "end-date": searchForm.get("end-date")
                }
                this.props.actionGet(page, bodyFInd);

            }, 3000);

        } else {
            if (PrevilageId != 1) {
                client_id = ClientId;
                division_id = DivisionId;
                if (this.state.actionId != 5) {

                    this.props.actionGetAllSender(client_id, division_id)
                } setTimeout(() => {
                    res = this.props.senderall;
                    if (res.size > 0) {
                        sender = [];
                    }
                    {
                        res.map((data, i) =>
                            sender.push(data.get('sender-id'))
                        )
                    }

                    if (sender_id != "") sender = [sender_id]
                    if (sender[0] == '') sender = []
                    bodyFInd = {
                        "client-id": client_id,
                        "division-id": division_id,
                        "sender-id": sender,
                        "start-date": searchForm.get("start-date"),
                        "end-date": searchForm.get("end-date")
                    }
                    this.props.actionGet(page, bodyFInd);
                }, 3000);
            } else {
                sender = [];
                sender.push(sender_id)
                if (sender[0] == '') sender = []
                bodyFInd = {
                    "client-id": client_id,
                    "division-id": division_id,
                    "sender-id": sender,
                    "start-date": searchForm.get("start-date"),
                    "end-date": searchForm.get("end-date")
                }
                this.props.actionGet(page, bodyFInd);
            }
        }
    }

    refreshGrid(page, search) {
        this.handleFindSearch(page)
    }

    handleFind() {
        this.handleFindSearch(1)
    }

    showContent() {
        var form = this.state.form;

        if (form.get('show')) {
            return (
                <Form
                    actionType={form.get('actionType')}
                    item={form.get('item')}
                    handleCancelForm={this.handleCancelForm}
                    handleSubmitOnForm={this.handleSubmitOnForm}
                >
                </Form>
            )
        } else {
            const items = this.props.mediaid ? fromJS(this.props.mediaid) : fromJS({});
            return (
                <CustomGrid
                    title="Upload File"
                    columns={this.state.columns}
                    items={items}
                    handleOnBindCustomAction={this.handleOnBindCustomAction}
                    handleCustomAction={this.handleCustomAction}
                    handlePageChanged={this.handlePageChanged}
                >
                </CustomGrid>
            )
        }
    }

    render() {
        const { searchForm, form } = this.state;
        const title = form.get('show') ?  "Upload File" : "Upload Media Id";
        const classHide = title == 'Upload Media Id' ? 'card' : 'card hidden'
        return (
            <div className="clearfix">
                <div className="card-noborder">
                    <h4>
                        {title}
                    </h4>
                </div>
                <div className={classHide}>
                    <div className="body">
                        <div className="row">
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='client-id'
                                    value={searchForm.get('client-id')}
                                    options={fromJS({
                                        'source': this.props.clientall,
                                        'value': 'client-id',
                                        'label': 'client-name'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Client"
                              //      disabled={this.state.disrest}
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='division-id'
                                    value={searchForm.get('division-id')}
                                    options={fromJS({
                                        'source': this.props.divisionall,
                                        'value': 'division-id',
                                        'label': 'division-name'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Division"
                                //    disabled={this.state.disrest}
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='sender-id'
                                    value={searchForm.get('sender-id')}
                                    options={fromJS({
                                        'source': this.props.senderall,
                                        'value': 'sender-id',
                                        'label': 'sender-name'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Sender"
                                  //  disabled={this.state.disrest}
                                />
                            </div>
                            <div className="col-sm-6">
                                <span className="col-sm-1">Start</span>
                                <div className="col-sm-4">
                                    <DatePickerInput
                                        dateFormat="yyyy-MM-dd"
                                        convertvalue
                                        field="start-date"
                                        value={searchForm.get('start-date')}
                                        onChange={(field, date) => this.handleChange(field, date)}
                                    />
                                </div>
                                <span className="col-sm-1">End</span>
                                <div className="col-sm-4">
                                    <DatePickerInput
                                        convertvalue
                                        dateFormat="yyyy-MM-dd"
                                        field="end-date"
                                        value={searchForm.get('end-date')}
                                        onChange={(field, date) => this.handleChange(field, date)}
                                        minDate={new Date(searchForm.get('start-date'))}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row no-margin-bottom" >
                            <div className="col-sm-2">
                                <button type="button"
                                    className="btn btn-wide btn-success"
                                    onClick={this.handleFind}>
                                    Search
                                </button>
                            </div>
                            <div className="col-sm-1"></div>
                            <div className="col-sm-2">
                                <button type="button"
                                    className="btn btn-wide btn-success content-add"
                                    onClick={this.handleNew}>
                                    Upload
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.showContent()
                }
            </div>
        );
    }
}


export default connect(
    (state) => {
        return {
            accessmodules: state.user.accessmodules,
            clientall: state.user.clientall,
            divisionall: state.user.divisionall,
            senderall: state.user.senders,
            mediaid: state.user.uploadmediaid
        }
    },
    dispatch => bindActionCreators({
        actionGetAllClient: ActionGetAllClient,
        actionGetAllDivision: ActionGetAllDivision,
        actionGetAllSender: ActionGetAllSender,
        actionGet:ActionGetMediaUpload,
        actionGetAccessModule: ActionGetAccessModule,
        actionDownload: ActionDownload
    }, dispatch),
)(Page);